import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { DashboardHeader } from '../components/DashboardHeader';
import { KpiRow } from '../components/KpiRow';
import { OccupancyForecast } from '../components/OccupancyForecast';
import { PricingRecommendations } from '../components/PricingRecommendations';
import { EventDemand } from '../components/EventDemand';
import { CompetitorRates } from '../components/CompetitorRates';
import { Sidebar } from '../components/Sidebar';
import { VipAlerts } from '../components/VipAlerts';
import { Horizon } from '../data/dashboardData';
import { useScreenInit } from '../useScreenInit.js';
export function Dashboard() {
  useScreenInit();
  const [property, setProperty] = useState('portfolio');
  const [horizon, setHorizon] = useState<Horizon>('7D');
  return <div className="flex min-h-screen w-full bg-[#eee9df] text-[#1a2c38]" data-id="element-179">
      <Sidebar data-id="element-180" />
      <div className="min-w-0 flex-1" data-id="element-181">
        <DashboardHeader property={property} onPropertyChange={setProperty} data-id="element-182" />
        <main className="px-4 py-5 sm:px-6 sm:py-6 xl:px-8" data-id="element-183">
          <div className="mx-auto max-w-[1500px] space-y-5" data-id="element-184">
            <KpiRow data-id="element-185" />
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.4,
            delay: 0.18
          }} className="grid grid-cols-1 gap-5 xl:grid-cols-12" data-id="element-186">
              <div className="space-y-5 xl:col-span-8" data-id="element-187">
                <OccupancyForecast horizon={horizon} onHorizonChange={setHorizon} data-id="element-188" />
                <div className="grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-189">
                  <EventDemand data-id="element-190" />
                  <CompetitorRates data-id="element-191" />
                </div>
              </div>
              <aside className="space-y-5 xl:col-span-4" aria-label="Revenue actions and alerts" data-id="element-192">
                <PricingRecommendations data-id="element-193" />
                <VipAlerts data-id="element-194" />
              </aside>
            </motion.div>
            <footer className="flex flex-col justify-between gap-2 border-t border-[#d3ccbf] py-3 text-[10px] text-[#807d75] sm:flex-row" data-id="element-195">
              <p data-id="element-196">
                Forecast model refreshed 08:42 CEST · Rate shop refreshed 08:15
                CEST
              </p>
              <p data-id="element-197">All figures shown in EUR · Excludes taxes and service</p>
            </footer>
          </div>
        </main>
      </div>
    </div>;
}